// extracted by mini-css-extract-plugin
export default {"div":"CerrarSesion_div__hVYbc","link":"CerrarSesion_link__8hqf7"};